import React, { Component } from 'react';
import './PageTitle.css';
import { Image } from 'pixboost-react';
import pixboostConfig from '../../../config/pixboost';
import EditBar from '../EditBar/EditBar';

class PageTitle extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      title,
      description,
      image,
      imageBasePath,
      sectionIndex,
      contentBlockIndex,
      removeContentBlock,
      backgroundColour,
      titleFontSize
    } = this.props;

    return (
      <div
        className={`page-title ${backgroundColour ? backgroundColour : ''} ${
          image ? 'has-image' : ''
        } edit-wrapper`}
      >
        <div className="text">
          {title && (
            <div className={`title ${titleFontSize ? titleFontSize : ''}`}>
              {title}
            </div>
          )}
          {description && <p className="description">{description}</p>}
        </div>
        {image && (
          <div className="image">
            <Image
              src={imageBasePath + image}
              alt={title}
              config={pixboostConfig}
              lazy={false}
            />
          </div>
        )}

        <EditBar
          toggleEditing={() => this.toggleEditing(true)}
          removeContentBlock={() =>
            removeContentBlock(sectionIndex, contentBlockIndex)
          }
        />
      </div>
    );
  }
}

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/landingPage/PageTitle/PageTitle.js